import { filter } from '@atlaskit/adf-utils/filter';
import type { ADFEntity } from '@atlaskit/adf-utils/types';

const EXTENSION_NODE_TYPES = new Set(['extension', 'bodiedExtension', 'inlineExtension']);

const extensionNodesByDocument = new WeakMap<ADFEntity, ADFEntity[]>();

export const collectExtensionNodes = (documentAdf: ADFEntity): ADFEntity[] => {
	const cachedExtensionNodes = extensionNodesByDocument.get(documentAdf);
	if (cachedExtensionNodes) {
		return cachedExtensionNodes;
	}

	const extensionNodes = filter(documentAdf, (node) => EXTENSION_NODE_TYPES.has(node.type));
	extensionNodesByDocument.set(documentAdf, extensionNodes);
	return extensionNodes;
};
